import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSlider } from '../../../../components/common/custom-slider';
import type { SliderSectionProps } from './types';

const SliderSection: FC<SliderSectionProps> = ({ data, popularPosts }) => {
    const { t } = useTranslation();

    return (
        <div className="bg-sliderSection">
            <div className="max-w-6xl mx-auto px-5">
                <div className="latest-slider">
                    <CustomSlider items={data.slice(0, 9)} title={t('home.latest_posts', 'Latest Posts')} />
                </div>
                <div className="popular-slider">
                    {!!popularPosts.length && <CustomSlider items={popularPosts} title={t('home.popular_posts', 'Popular Posts')} />}
                </div>
            </div>
        </div>
    );
};

export default SliderSection;
